import { CreateTaskDto, Task, TaskStatus, UpdateTaskDto } from '../../types';
import api from './client';

// Tasks Service
export const tasksService = {
  createTask: async (task: CreateTaskDto): Promise<Task> => {
    const response = await api.post<Task>('/tasks', task);
    return response.data;
  },
  getAllTasks: async (): Promise<Task[]> => {
    const response = await api.get<Task[]>('/tasks');
    return response.data;
  },
  getTaskById: async (id: string): Promise<Task> => {
    const response = await api.get<Task>(`/tasks/${id}`);
    return response.data;
  },
  getTasksByAppointmentId: async (appointmentId: string): Promise<Task[]> => {
    const response = await api.get<Task[]>(`/tasks/appointment/${appointmentId}`);
    return response.data;
  },
  updateTask: async (id: string, updateData: UpdateTaskDto): Promise<Task> => {
    const response = await api.patch<Task>(`/tasks/${id}`, updateData);
    return response.data;
  },
  updateTaskStatus: async (id: string, status: TaskStatus): Promise<Task> => {
    const response = await api.patch<Task>(`/tasks/${id}/status`, { status });
    return response.data;
  },
  deleteTask: async (id: string): Promise<void> => {
    await api.delete(`/tasks/${id}`);
  },
  notifyCustomer: async (taskId: string): Promise<void> => {
    await api.post(`/tasks/${taskId}/notify`);
  },
};
